import React, {useEffect, useState} from 'react'
import SuccessModal from "../../CustomModal/Success";
import FailedModal from "../../CustomModal/Failed";
import Header from "../../layout/header";
import BottomMenu from "../../layout/bottomMenu";
import Loader from "../../../Loader/Loader";
import useLatLng from "../../../hooks/uselatlng/uselatlng";
import "../../Dashboard/Dashboard.css";
import "../../Dashboard/Sidebar";
import DashboardMenu from "../../layout/dashboardMenu";
import {toast} from "react-toastify";

const CarServiceOpportunities = ({
                                 getOpportunity,
                                 opportunityTypes = [],
                                 save,
                                 saveDetails = [],
                                 match,
                                 history
                             }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [inputList, setInputList] = useState([{}])
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const islatlng = useLatLng();
    const [isAllow, setIsAllow] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState('')
    const [opportunity, setOpportunities] = useState([{opportunity_type_id:""}])

    useEffect(async () => {
        setIsLoading(true)
        await getOpportunity('is_car_service')
        setIsLoading(false)
    }, [])


    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (saveDetails?.status === 200) {
            setIsSuccessModalOpen(true)
            setRedirectUrl('car-service-opportunity-list/'+match?.params?.id)
        } else if (saveDetails?.status !== undefined && saveDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
        }
    }, [saveDetails])

    const handleOpportunity = (val, value, i, e) => {
        let list = [...opportunity]
        let isReady = false
        opportunity.map((v, i) => {
            if(v?.opportunity_type_id === value){
                isReady = true
            }
        })

        if(isReady){
            handleRemoveOpportunity(e, i)
            toast.error("Already Added")
            return false
        }
        list[i][val] = value
        setOpportunities(list)
    }

    const handleAddOpportunity = () => {
        setOpportunities([
            ...opportunity,
            {opportunity_type_id: ''}
        ])
    }

    const handleRemoveOpportunity = (e, index) => {
        e.preventDefault()
        const list = [...opportunity]
        list.splice(index, 1);
        setOpportunities(list);
    }

    /**
     * @param e
     * @returns {Promise<void>}
     */
    const handleSubmit = async (e) => {
        e.preventDefault()
        inputList[0]['latitude'] = islatlng?.lat
        inputList[0]['longitude'] = islatlng?.lng
        if(inputList[0]['longitude'] == null || inputList[0]['latitude'] == null){
            toast.error('Please enable your location');
            return false
        }

        inputList[0]['account_id'] = match?.params?.id
        inputList[0]['opportunity_type_id'] = opportunity
        inputList[0]['not_new_activity'] = true
        // not in use, have used api to save opportunity for apartment , corporate, valet and supply
        inputList[0]['details'] = [""]
        setIsLoading(true)
        await save(inputList[0])
        setIsLoading(false)
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={saveDetails?.message}
                url={redirectUrl}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={saveDetails?.message}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Add Opportunity"}
                            history={history}
                        />
                        {/*BODY*/}
                        <div className="container-fluid">
                            {/*Heading*/}
                            {/* <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-black-100">Add Opportunities</h1>
                            </div> */}
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            {/* <div className="card-header bg-lightGreen-active">
                                                Opportunities
                                            </div> */}
                                            <div className="card-body">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        {opportunity.map((values, ii) => {
                                                            return (
                                                                <>
                                                                    <div className="col-sm-6 mt-1 float-field">
                                                                        <select
                                                                            className="form-control form-control-user"
                                                                            onChange={(e) => {
                                                                                handleOpportunity('opportunity_type_id', e.target.value, ii, e)
                                                                            }}
                                                                            required={true}
                                                                        >
                                                                            <option value="">Select Opportunity Type</option>
                                                                            {opportunityTypes?.data !== undefined && opportunityTypes?.data.map((val) => {
                                                                                return (
                                                                                    <>
                                                                                        {parseInt(values?.opportunity_type_id) === parseInt(val?.id) ?
                                                                                            <option
                                                                                                value={val?.id} selected>{val.name}
                                                                                            </option> :
                                                                                            <option
                                                                                                value={val?.id}>{val.name}
                                                                                            </option>}
                                                                                    </>
                                                                                )
                                                                            })}
                                                                        </select>
                                                                            <label className="large-label float-lb">
                                                                                Opportunity Type
                                                                            </label>
                                                                    </div>

                                                                    <div
                                                                        className="btn-box mb-2">
                                                                        {opportunity.length !== 1 &&
                                                                            <>
                                                                                <button
                                                                                    onClick={(e) => handleRemoveOpportunity(e, ii)}
                                                                                    className="btn btn-sm btn-danger ml-3 btn-ar">Remove
                                                                                    Opportunity
                                                                                </button>
                                                                            </>
                                                                        }
                                                                        {opportunity.length - 1 === ii &&
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-primary ml-3 btn-ar mt-4"
                                                                                onClick={() => handleAddOpportunity()}>Add
                                                                                Opportunity
                                                                            </button>}
                                                                    </div>
                                                                </>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default CarServiceOpportunities